class Forum  {
    constructor() {
        this.processingSubmit = false;
        this.currentPage = 0;
        this.pageCount = 0;
        this.pageSize = 15;
        this.lastPage = 0;
        this.categoryId = 0;   
        this.topicId = 0;         
        this.forumContentId = 0;
        this.forumAdmin = false;        
        this.canAddTopic = false;        
        this.contentForumMode = false;
        this.mainContainerId = null;  
        this.viewType = "list-view";
    }    

    /* Internal methods */

    _clearMessageForm() {
        let $form = $("div.messageFormContainer", this._getContainer());
        $("input#ReplyToMessageId", $form).val(0);
        $("input#MessageId", $form).val(0);
        $("input#IsQuestion", $form).val(false);
        $("input#IsQuestion", $form).prop("checked", false);
        $("textarea.forumMessageBody", $form).val("");

        $("span.replyHeadSpan", $form).text("");
        $("span.replyToMessageSpan", $form).hide();        
    }

    _getCategory(categoryId) {
        let deferred = $.Deferred();

        if (!categoryId || categoryId === 0) {
            deferred.resolve(null);
            return deferred.promise();
        }

        $.ajax({
            url: `/forum/category/${categoryId}`,
            method: "GET",
            success(result) {
                deferred.resolve(result);
            },
            error(e) {
                console.warn(e);
                deferred.resolve(null);
            },
            dataType: "json"
        });
        return deferred.promise();
    }

    //_getContentTopic(contentId) {
    //    let deferred = $.Deferred();

    //    if (!contentId || contentId === 0) {
    //        deferred.resolve(null);
    //        return deferred.promise();
    //    }

    //    $.ajax({
    //        url: `/forum/topic/content/${contentId}`,
    //        method: "GET",
    //        success(result) {
    //            deferred.resolve(result);
    //        },
    //        error(e) {
    //            console.warn(e);
    //            deferred.resolve(null);
    //        },
    //        dataType: "json"
    //    });
    //    return deferred.promise();
    //}

    _getContainer() {
        if (this.mainContainerId && this.mainContainerId.trim().length > 0) {
            $(`div#${this.mainContainerId}`);
        }
        return $("body");
    }

    _getMessage(messageId) {
        let deferred = $.Deferred();

        if (!messageId || messageId === 0) {
            deferred.resolve(null);
            return deferred.promise();
        }

        $.ajax({
            url: `/forum/message/${messageId}`,
            method: "GET",
            success(result) {
                deferred.resolve(result);
            },
            error(e) {
                console.warn(e);
                deferred.resolve(null);
            },
            dataType: "json"
        });
        return deferred.promise();
    }

    _getTopic(topicId) {
        let deferred = $.Deferred();

        if (!topicId || topicId === 0) {
            deferred.resolve(null);
            return deferred.promise();
        }

        $.ajax({
            url: `/forum/topic/${topicId}`,
            method: "GET",
            success(result) {
                deferred.resolve(result);
            },
            error(e) {
                console.warn(e);
                deferred.resolve(null);
            },
            dataType: "json"
        });
        return deferred.promise();
    }

    _getUserInfo(userId) {
        let deferred = $.Deferred();

        if (!userId || userId.trim().length === 0) {
            deferred.resolve(null);
            return deferred.promise();
        }

        $.ajax({
            url: `/account/userinfo/${userId}`,
            method: "GET",
            success(result) {
                deferred.resolve(result);
            },
            error(e) {
                console.warn(e);
                deferred.resolve(null);
            },
            dataType: "json"
        });
        return deferred.promise();
    }

    _incrementTopicViewCount(topicId) {
        const url = `/forum/topic/viewcount/${topicId}`;
        $.post(url, {}, () => {
        });
    }

    _loadPage() {
        const url = `/forum/messages/${this.topicId}`;
        this._loadUrl("div.forumContent", url, { currentPage: this.currentPage, pageSize: this.pageSize, contentForumMode: this.contentForumMode });
    }

    _loadUrl(selector, url, postData) {

        let deferred = $.Deferred();
        if (!postData) {
            postData = {};
        }

        $.get(url, postData, (html) => {
            $(selector, this._getContainer()).html(html);
            deferred.resolve(true);            
        });

        return deferred.promise();
    }

    _onCategoryError(result) {
        let message = "Error occurred while saving category.";
        if (result && result.status === 400 && typeof result.responseText === "string" && result.responseText.trim().length > 0) {
            message = result.responseText;
        }

        let $span = $("span.saveResultContainer", this._getContainer());
        $span.removeClass("text-green-500").addClass("text-red-500").text(message);
        $span.show();
        setTimeout(() => { $span.hide(); }, 5000);
    }

    _onPostSuccess(result) {
        this.processingSubmit = false;
        let $span = $("span.saveResultContainer", this._getContainer());

        if (result.HasError === true) {
            $span.removeClass("text-green-500").addClass("text-red-500").text(result.Message);
            $span.show();
            setTimeout(() => { $span.hide(); }, 5000);
        }
        else {
            if ($("input#ReplyToMessageId", this._getContainer()).val() === "0") {
                this.currentPage = -1;
            }
            this._loadPage();
        }
    }

    _onPostError(result) {
        let $span = $("span.saveResultContainer", this._getContainer());
        $span.removeClass("text-green-500").addClass("text-red-500").text("Error occurred while posting reply.");
        $span.show();
        setTimeout(() => { $span.hide(); }, 5000);
        this.processingSubmit = false;
    }

    _onTopicSuccess(result) {
        this.loadTopics(this.categoryId);
    }

    _onTopicError() {
        let $span = $("span.saveResultContainer", this._getContainer());
        $span.removeClass("text-green-500").addClass("text-red-500").text("Error occurred while saving topic.");
        $span.show();
        setTimeout(() => { $span.hide(); }, 5000);
    }  

    _showCreateCategoryLink() {
        let $container = this._getContainer();
        $("div.createTopicLink", $container).hide();
        $("div.createPostLink", $container).hide();
        $("div.createCategoryLink", $container).show();        
    }

    _showCreateTopicLink() {
        let $container = this._getContainer();
        $("div.createCategoryLink", $container).hide();        
        $("div.createPostLink", $container).hide();
        $("div.createTopicLink", $container).show();

        if (this.forumAdmin === true || this.canAddTopic === true) {
            $("div.createTopicLink input", $container).show();
        }
        else {
            $("div.createTopicLink input", $container).hide();
        }
    }

    _showPostMessageLink() {
        let $container = this._getContainer();
        $("div.createCategoryLink", $container).hide();
        $("div.createTopicLink", $container).hide();
        $("div.createPostLink", $container).show();
    }       

    _toggleMessageForm() {
        let $container = this._getContainer();
        let $form = $("div.messageFormContainer", $container);
        let $msgs = $("div.forumMsgsContainer", $container);
        if ($form.is(":visible")) {
            $($form).slideUp("fast", () => {                
                $msgs.slideDown();
                $("div.createPostLink", $container).show();
            });
        }
        else {
            $msgs.slideUp("fast", () => {                
                $form.slideDown();
                $("div.createPostLink", $container).hide();
                $("textarea#MessageBody", $form).focus();
            });
        }

        // show/hide bread crumbs/topic title
        if (this.contentForumMode === true) {            
            $("div.forumTopicDiv", $form).show();
            $("div.forumBreadcrumbsDiv", $form).hide();
        }
        else {
            $("div.forumTopicDiv", $form).hide();
            $("div.forumBreadcrumbsDiv", $form).show();
        }
    }        

    /* End Internal methods */

    cancelPost() {
        this._clearMessageForm();
        this._toggleMessageForm();
    }

    initPager (recordCount, pageSize, currentPage) {
        this.currentPage = currentPage;
        this.pageSize = pageSize;
        this.pageCount = Math.ceil(recordCount / pageSize);
        this.lastPage = (this.pageCount > 1) ? (this.pageCount - 1) : 0;

        if (this.pageCount <= 1) return;

        const $pagerDiv = $("div.forumPager");
        $pagerDiv.show();

        if (this.currentPage === 0) {
            $("span.firstPage", $pagerDiv).addClass("disabled");
            $("span.previousPage", $pagerDiv).addClass("disabled");
        }
        if (this.currentPage === 0 && this.currentPage < (this.pageCount - 1)) {
            $("span.nextPage", $pagerDiv).removeClass("disabled");
            $("span.lastPage", $pagerDiv).removeClass("disabled");
        }
        if (this.currentPage > 0) {
            $("span.firstPage", $pagerDiv).removeClass("disabled");
            $("span.previousPage", $pagerDiv).removeClass("disabled");
        }
        if (this.currentPage > 0 && this.currentPage >= this.lastPage) {
            $("span.nextPage", $pagerDiv).addClass("disabled");
            $("span.lastPage", $pagerDiv).addClass("disabled");
        }
        if (this.currentPage === this.lastPage) {
            $("span.nextPage", $pagerDiv).addClass("disabled");
            $("span.lastPage", $pagerDiv).addClass("disabled");
        }
        else if (this.currentPage < this.lastPage) {
            $("span.nextPage", $pagerDiv).removeClass("disabled");
            $("span.lastPage", $pagerDiv).removeClass("disabled");
        }

        $("select.forumPages", $pagerDiv).change((e) => {            
            let newPage = $(e.target).val();
            this.currentPage = newPage;
            this._loadPage();
        });

        $("span.firstPage", $pagerDiv).click(() => {
            if (this.currentPage > 0) {
                this.currentPage = 0;
                this._loadPage();
            }
        });

        $("span.previousPage", $pagerDiv).click(() => {
            if (this.currentPage > 0) {
                this.currentPage = this.currentPage - 1;
                this._loadPage();
            }
        });
        $("span.lastPage", $pagerDiv).click(() => {
            if (this.currentPage !== (this.pageCount - 1)) {
                this.currentPage = this.lastPage;
                this._loadPage();
            }
        });
        $("span.nextPage", $pagerDiv).click(() => {
            if (this.currentPage < (this.pageCount - 1)) {
                this.currentPage = this.currentPage + 1;
                this._loadPage();
            }
        });
    }

    loadCategories() {                
        this.categoryId = 0;
        this.topicId = 0;        
        const url = `/forum/categories/${this.forumContentId}`;
        this._loadUrl("div.forumContent", url, null).then(() => {
            this._showCreateCategoryLink();
            let link = $(`a.linkViewType[data-view='${this.viewType}']`);
            if (link.length > 0) {
                this.toggleView(link[0]);
            }
        });
    }

    loadTopics(categoryId) {        
        this.categoryId = categoryId;        
        this.topicId = 0;
        const url = `/forum/topics/${categoryId}`;        
        this._loadUrl("div.forumContent", url, null).then(() => { this._showCreateTopicLink(); });        
    }

    loadMessages(topicId) {        
        this.topicId = topicId;                
        const url = `/forum/messages/${topicId}`;
        this._loadUrl("div.forumContent", url, { pageSize: this.pageSize, currentPage: this.currentPage }).then(() => { this._showPostMessageLink(); });        
        this._incrementTopicViewCount(topicId);
    }

    editTopic(topicId, categoryId) {                
        if (!categoryId) {
            categoryId = this.categoryId;
        }        
        const url = `/forum/topic/${topicId}/edit?categoryId=${categoryId}`;
        this._loadUrl("div.forumContent", url);
        return false;
    }

    editCategory(e, categoryId) {        
        e.preventDefault();
        e.stopPropagation();

        const url = `/forum/category/${categoryId}/edit?forumContentId=${this.forumContentId}`;
        this._loadUrl("div.forumContent", url);
        $("div.createCategoryLink").hide();        
    }

    deleteCategory(categoryId) {
        if (!categoryId) { return; }

        if (confirm("Deleting category will also delete all related records.\n\nAre you sure you want to delete this category?")) {

            $.ajax({
                url: `/forum/category/${categoryId}`,
                method: "DELETE",
                dataType: "json"
            })
                .done((success) => {
                    if (success !== true) {
                        alert("Unable to delete category.");
                    }
                    else {
                        this.loadCategories();
                    }
                })
                .fail((result) => {
                    console.warn(result.resultText);
                });
        }
    }
    
    deleteMessage(messageId, topicId) {
        if (!messageId) { return; }

        $(`div.forum-msg-menu.${messageId}`, this._getContainer()).hide();

        if (confirm("Are you sure you want to delete this message?")) {
            $.ajax({
                url: `/forum/message/${messageId}`,
                method: "DELETE",
                dataType: "json"
            })
                .done((result) => {
                    const $container = $("div.forumContent", this._getContainer()); 
                    $("#divForumMessage" + messageId, $container).hide("slow", () => {
                        $(this).remove();
                        // clear reply to messageId if applicable
                        if (messageId === $("input#ReplyToMessageId", $container).val()) {
                            this.clearMessageForm();
                        }
                    });
                })
                .fail((result) => {
                    console.warn(result.resultText);
                });
        }
    }

    deleteTopic(topicId, categoryId) {
        if (!topicId) { return; }

        if (confirm("Deleting topic will also delete all related records.\n\nAre you sure you want to delete this topic?")) {

            $.ajax({
                url: `/forum/topic/${topicId}`,
                method: "DELETE",
                dataType: "json"
            })
                .done((success) => {
                    if (success !== true) {
                        alert("Unable to delete topic.");
                    }
                    else {
                        if (categoryId > 0) {
                            this.loadTopics(categoryId);
                            return;
                        }
                        this.loadCategories();
                    }
                })
                .fail((result) => {
                    console.warn(result.resultText);
                });
        }
    }

    editMessage(el, messageId) {

        $(`div.forum-msg-menu.${messageId}`, this._getContainer()).hide();
        
        $.get(`/forum/message/${messageId}/edit`, (result) => {
            $("div.messageFormContainer", this._getContainer()).remove();
            $("div.forumContent", this._getContainer()).append(result);

            let $form = $("div.forumMessageFormDiv", this._getContainer());
            let color = 
            $("span.editMessageBy", $form).text($(el).attr("data-createdby"));
            $("span.editMessageDate", $form).text($(el).attr("data-createddate"));            
            $("span.editMessageBy", $form).css("color", $(el).attr("data-usercolor"));
            

            $("div.replyToMessageTitle", $form).hide();
            $("div.replyToMessageBody", $form).hide();            
            $("div.messageIsQuestionDiv", $form).hide();            

            $("div.editMessageTitle", $form).show();            
            $("div.replyToMessageDiv", $form).show();    

            this._toggleMessageForm();                            
        });        
    }
        
    markAsAnswer(messageId, replyToMessageId) {    

        if (!messageId || !replyToMessageId) { return; }
        
        $.post(`/forum/message/${replyToMessageId}/answer/${messageId}`, {}, () => { 
            
            const $msgDiv = $("#divForumMessage" + replyToMessageId, this._getContainer());
            $("div.checkedImage", $msgDiv).addClass("hidden");
            $("a.markAsAnswerLink", $msgDiv).removeClass("hidden");
            $("div.secondLevelPost div.forum-msg-content", $msgDiv).removeClass("answer");

            const $answerDiv = $("#divForumMessage" + messageId, this._getContainer());
            $("div.checkedImage", $answerDiv).removeClass("hidden");
            $("a.markAsAnswerLink", $answerDiv).addClass("hidden");
            $("div.secondLevelPost div.forum-msg-content", $answerDiv).addClass("answer");
            $("div.forum-msg-menu", $answerDiv).hide();
        });
    }

    openContentForum(contentId, overlayOptions) {
        if (!contentId) { return; }

        const options = {};
        if (overlayOptions) {
            $.extend(options, overlayOptions);
        }
        const url = `/forum/content/${contentId}`;
        window.SCOverlay.show(url, options);
    }

    openCategory(categoryId, overlayOptions) {
        if (!categoryId) { return; }

        // get category data
        this._getCategory(categoryId).then( (category) => {

            if (!category || typeof category !== "object") { return; }

            const options = {};
            if (overlayOptions) {
                $.extend(options, overlayOptions);
            }
            
            const url = `/forum/0?categoryId=${categoryId}`;
            window.SCOverlay.show(url, options);
        });
    }

    openForum(forumContentId, overlayOptions) {
        if (!forumContentId) {
            forumContentId = 0;
        }
        const options = {};
        if (overlayOptions) {
            $.extend(options, overlayOptions);
        }
        const url = `/forum/${forumContentId}`;
        window.SCOverlay.show(url, options);
    }

    openTopic(topicId, overlayOptions) {
        if (!topicId) { return; }

        // get topic data
        this._getTopic(topicId).then((topic) => {

            if (!topic || typeof topic !== "object") { return; }

            const options = {};
            if (overlayOptions) {
                $.extend(options, overlayOptions);
            }

            // topic is for content
            if (topic.forContentId > 0) {
                this.openContentForum(topic.forContentId);
                return;
            }

            const url = `/forum/0?topicId=${topicId}`;
            window.SCOverlay.show(url, options);
        });
    }

    postMessage(topicId) {

        if (!topicId) {
            topicId = this.topicId;
        }

        $.get(`/forum/message/0/edit`, { topicId: topicId }, (result) => {
            $("div.messageFormContainer").remove();
            $("div.forumContent", this._getContainer()).append(result);
            this._toggleMessageForm();
        });
    }

    readMoreTopic(el, topicId) {
        if (!topicId) { return; }
        let $topic = $("a.forum-topic[data-topic-id=" + topicId + "]", this._getContainer());
        if ($topic.length === 0) { return; }
        let $preview = $("div.topic-description.preview", $topic);
        let $fullview = $("div.topic-description.fullview", $topic);
        if ($fullview.length > 0) {
            $(el).hide();
            $preview.hide();            
            $fullview.slideToggle();
        }
    }

    replyToMessage(el, messageId, topicId) {
        if (!topicId) {
            topicId = this.topicId;
        }

        $.get(`/forum/message/0/edit`, { topicId: topicId }, (result) => {
            $("div.messageFormContainer", this._getContainer()).remove();
            $("div.forumContent", this._getContainer()).append(result);

            let $form = $("div.forumMessageFormDiv", this._getContainer());

            $("input#ReplyToMessageId", $form).val(messageId);
            $("span.replyToMessageBy", $form).text($(el).attr("data-createdby"));
            $("span.replyToMessageBy", $form).css("color", $(el).attr("data-usercolor"));

            // get reply to message data
            this._getMessage(messageId).then((msg) => {
                if (!msg || typeof msg !== "object") { return; }

                $("span.replyToMessageBody", $form).text(msg.messageBody);                
            });            

            $("div.messageIsQuestionDiv", $form).hide();
            $("div.editMessageTitle", $form).hide();
            
            $("div.replyToMessageTitle", $form).show();            
            $("div.replyToMessageBody", $form).show();            
            $("div.replyToMessageDiv", $form).show();            

            this._toggleMessageForm();
        });
    }
     
    saveMessage() {

        if (this.processingSubmit === true) {
            console.log("multiple submit detected and ignored");
            return false;
        }
        
        const url = "/forum/SaveMessage";
        const $container = this._getContainer();
        
        $("#frmMessage", $container).ajaxSubmit({
            beforeSubmit: () => {
                let $form = $("#frmMessage", $container);
                let isValid = $form.valid();
                if (!isValid) {
                    $("#frmMessage .error:eq(0)", $container).focus();
                }
                this.processingSubmit = isValid;
                return isValid;
            },
            url: url,
            dataType: "json",
            type: "POST",
            success: this._onPostSuccess.bind(this),
            error: this._onPostError.bind(this)
        });

        return false;
    }

    saveTopic() {
        const $container = this._getContainer();
        $("#frmTopic", $container).ajaxSubmit({
            beforeSubmit: () => {
                let isvalid = $("#frmTopic", $container).valid();
                if (!isvalid) $("#frmTopic .error:eq(0)", $container).focus();
                return isvalid;
            },
            url: "/forum/SaveTopic",
            dataType: "json",
            type: "POST",
            success: this._onTopicSuccess.bind(this),
            error: this._onTopicError.bind(this)
        });

        return false;
    }

    saveCategory() {
        const $container = this._getContainer();        
        $("#frmCategory", $container).ajaxSubmit({
            beforeSubmit: () => {
                let isvalid = $("#frmCategory", $container).valid();
                if (!isvalid) {
                    $("#frmCategory .error:eq(0)", $container).focus();
                }

                return isvalid;
            },
            url: "/forum/SaveCategory",
            dataType: "json",
            type: "POST",
            success: () => { this.loadCategories(); },
            error: (result) => { this._onCategoryError(result); }
        });

        return false;
    }

    search(e) {
        if (e.type === "keypress" && e.which !== 13) { return };

        e.preventDefault();
        e.stopPropagation();

        const keyword = $("input.forumSearchKeyword", this._getContainer()).val();
        const filter = $("select.forumSearchFilter", this._getContainer()).val();

        if ((keyword && keyword.trim().length > 0) || (filter && filter != "0")) {
            let data = { keyword: keyword };
            if (filter.startsWith("c:")) {
                data.categoryId = filter.replace("c:", "");
            }
            if (filter.startsWith("t:")) {
                data.topicId = filter.replace("t:", "");
            }            
            const url = "/forum/search";
            this._loadUrl("div.forumContent", url, data);
        }
        else {
            alert("Please enter search keyword and/or select filter.");
            $(e.target).focus();
        }
    }   
    
    showMessageMenu(el) {
        if (!el) { return; }

        let $container = this._getContainer();        
        let msgId = $(el).attr("data-msgid");
        let $msgDiv = $("#divForumMessage" + msgId, $container);
        let $menu = $(`div.forum-msg-menu.${msgId}`, $msgDiv); 

        // hide open menus
        $("div.forum-msg-menu", $container).hide();           

        if ($menu.length === 0) { return; }        

        // show selected menu
        $menu.show();   

        $(document).on("mouseup.forummessagemenu", (e) => {
            // if the target of the click isn't the container nor a descendant of the menu
            if (!$menu.is(e.target) && $menu.has(e.target).length === 0) {
                $menu.hide();
                $(document).off("mouseup.forummessagemenu");
            }
        });
    }   

    showUserInfo(el, e, showLeftOfCursor) {      
        
        let $div = $("div.user-info", this._getContainer());
        let userId = $(el).attr("data-uid");
        let msgId = $(el).attr("data-msgid");               
        
        let xpos = e.pageX - $div.parent().offset().left + 20;
        let ypos = e.pageY - $div.parent().offset().top - 30;
        let currentMsgId = $div.attr("data-msgid");

        if ($div.is(":visible") && currentMsgId === msgId) { return; }

        $("div.user-info-tooltip", $div).removeClass("left");
        if (showLeftOfCursor === true) {
            $("div.user-info-tooltip", $div).addClass("left");
        }
                
        $div.css({ top: ypos, left: xpos });

        this._getUserInfo(userId).then((user) => {
            if (user && typeof user === "object") {
                let html = `<div><b>${user.firstName} ${user.lastName}</b></div>`;
                if (user.title) {
                    html += `<div class="text-sm">Title: ${user.title}</div>`;
                }
                if (user.organization) {
                    html += `<div class="text-sm">Organization: ${user.organization} </div>`;
                }
                if (user.specialty) {
                    html += `<div class="text-sm">Primary Role: ${user.specialty}</div>`;
                }
                
                $("div.user-info-tooltip", $div).html(html);
                $div.attr("data-msgid", msgId);

                $div.show();

                if (showLeftOfCursor === true) {
                    $div.css({ top: ypos, left: xpos - ($div.width() + 40) });
                }                

                $(document).on("mouseup.userinfo", (e) => {
                    // if the target of the click isn't the container nor a descendant of the menu
                    if (!$div.is(e.target) && $div.has(e.target).length === 0) {
                        $div.hide();
                        $(document).off("mouseup.userinfo");
                    }
                });
            }
        });        
    }   

    toggleCreateButtons() {
        if (this.topicId > 0) {
            this._showPostMessageLink();
            return;
        }
        if (this.categoryId > 0) {
            this._showCreateTopicLink();
            return;
        }
    }

    toggleView(el) {
        if (!el) { return; }

        var view = $(el).data("view");
        var $container = this._getContainer();
        var $categories = $("div.forum-categories-content", $container);
        $categories.removeClass("grid-view list-view flex flex-wrap").addClass(view);
        if (view === "grid-view") {
            $categories.addClass("flex flex-wrap");
        }
        $("a.linkViewType", $container).removeClass("selected");
        $(el).addClass("selected");        

        this.viewType = view;
    }
};

export default new Forum();


/*
highlight v3
Highlights arbitrary terms.
<http://johannburkard.de/blog/programming/javascript/highlight-javascript-text-higlighting-jquery-plugin.html>
MIT license.
Johann Burkard
<http://johannburkard.de>
<mailto:jb@eaio.com>
*/

jQuery.fn.highlight = function (pat) {
    function innerHighlight(node, pat) {
        var skip = 0;
        if (node.nodeType == 3) {
            var pos = node.data.toUpperCase().indexOf(pat);
            if (pos >= 0) {
                var spannode = document.createElement('span');
                spannode.className = 'highlight';
                var middlebit = node.splitText(pos);
                var endbit = middlebit.splitText(pat.length);
                var middleclone = middlebit.cloneNode(true);
                spannode.appendChild(middleclone);
                middlebit.parentNode.replaceChild(spannode, middlebit);
                skip = 1;
            }
        }
        else if (node.nodeType == 1 && node.childNodes && !/(script|style)/i.test(node.tagName)) {
            for (var i = 0; i < node.childNodes.length; ++i) {
                i += innerHighlight(node.childNodes[i], pat);
            }
        }
        return skip;
    }
    return this.each(function () {
        innerHighlight(this, pat.toUpperCase());
    });
};
